import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useSettingsState } from "@/context/SettingsStateContext";
import { useSettings } from "@/context/SettingsContext";

export default function WritingStyleCard() {
  const { styleInput, setStyleInput } = useSettingsState();
  const { restoreDefaultWritingStyle } = useSettings();

  return (
    <Card id="writing">
      <CardHeader>
        <CardTitle>Writing style</CardTitle>
        <CardDescription>
          Define your preferred writing style and tone for content generation
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="writing-style">Content Writing Style</Label>
          <Textarea
            id="writing-style"
            value={styleInput}
            onChange={(e) => setStyleInput(e.target.value)}
            placeholder="e.g., Professional, Conversational, Technical, Educational. You can also add specific details about tone, vocabulary level, and writing approach."
            className="min-h-[200px]"
          />
          <div className="flex justify-end">
            <Button variant="outline" size="sm" onClick={restoreDefaultWritingStyle}>
              Restore Default
            </Button>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Specify your preferred writing style to guide content generation. This affects
          tone, vocabulary, and overall presentation.
        </p>
      </CardContent>
    </Card>
  );
}
